import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("td", { height: "35" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_cell = _resolveComponent("user-cell")

  return (_openBlock(), _createBlock("tr", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.user.days, (day) => {
      return (_openBlock(), _createBlock(_component_user_cell, {
        key: day.formattedDate,
        user: _ctx.user,
        day: day
      }, null, 8, ["user", "day"]))
    }), 128))
  ]))
}